var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-modal-overlay"},[_vm._t("default"),(_vm.closeBtn)?_c('div',{staticClass:"side-modal-overlay__close-btn",on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }